import React, { useMemo } from 'react';
import 'Components/Modals/PaymentModal/index.css';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  usePromoCodeInputContext,
} from 'Context/PromoCodeInputContext';
import { dataAttrs } from 'Helpers/Testing';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import LeadPromosLayout from './LeadPromoLayout';
import { leadPromoOverrides } from './leadPromoOverrides';

const useStyles = buildUseStyles('LeadPromoInput', (theme) => ({
  link: {
    color: theme.palette.primary.main,
  },
}));

const LeadPromoInput = ({
  collection, refreshCollection, loading, setLoading,
}) => {
  const classes = useStyles();
  const numPromosInCollection = useMemo(() => collection.resources().length(), [collection]);
  const { setPromoCodeInputIsFilled, promoCodeInputResource, setPromoCodeInputResource } = usePromoCodeInputContext();
  return (
    <>
      {promoCodeInputResource ? (
        <MetaFormInline
          resource={promoCodeInputResource}
          padding="none"
          layout={LeadPromosLayout}
          noIndividualSubmitButtons
          noIndividualDeleteButtons
          onChange={(attr, val) => {
            if (attr === 'code') setPromoCodeInputIsFilled(!!val);
          }}
          onRemove={() => {
            setPromoCodeInputIsFilled(false);
            setPromoCodeInputResource(undefined);
          }}
          onSubmit={async () => {
            setPromoCodeInputIsFilled(false);
            await refreshCollection();
            setPromoCodeInputResource(undefined);
          }}
          LayoutProps={{ collection, loading, setLoading }}
          metaOverrideSet={leadPromoOverrides}
        />
      ) : (
        <a
          className={classes.link}
          href="#"
          onClick={(e) => {
            setPromoCodeInputResource(collection.create({ useCollectionMetaOverrideSet: true }));
            e.preventDefault();
          }}
          {...dataAttrs('open promo entry')}
        >I have {numPromosInCollection > 0 ? 'another' : 'a'} promo code
        </a>
      )}
    </>
  );
};

LeadPromoInput.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  refreshCollection: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default LeadPromoInput;
